var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 244,
    viewBox: "0 0 136 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439 -80H-293C-297.418 -80 -301 -76.4183 -301 -72V524C-301 528.418 -297.418 532 -293 532H439C443.418 532 447 528.418 447 524V-72C447 -76.4183 443.418 -80 439 -80Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439 -80H-293C-297.418 -80 -301 -76.4183 -301 -72V524C-301 528.418 -297.418 532 -293 532H439C443.418 532 447 528.418 447 524V-72C447 -76.4183 443.418 -80 439 -80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3697 0.621169L125.361 0.460611C130.884 0.452899 135.368 4.9238 135.375 10.4466L135.686 233.327C135.694 238.85 131.223 243.333 125.7 243.341L10.7089 243.501C5.18602 243.509 0.702625 239.038 0.694913 233.515L0.383714 10.6351C0.376002 5.11228 4.8469 0.628881 10.3697 0.621169Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4818 3.12715L122.256 2.97527C127.779 2.96756 132.262 7.43846 132.27 12.9613L132.565 224.058C132.573 229.581 128.102 234.064 122.579 234.072L13.8045 234.224C8.28163 234.232 3.79823 229.761 3.79052 224.238L3.49577 13.1411C3.48806 7.61826 7.95896 3.13486 13.4818 3.12715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0445 19.4601L117.74 19.3205L118.002 207.384L18.3064 207.524L18.0445 19.4601Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1869 228.97C72.5773 228.964 76.1314 225.391 76.1253 220.99C76.1191 216.589 72.555 213.026 68.1646 213.032C63.7742 213.038 60.2201 216.611 60.2262 221.012C60.2324 225.413 63.7965 228.976 68.1869 228.97Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 13C53.3284 13 54 12.3284 54 11.5C54 10.6716 53.3284 10 52.5 10C51.6716 10 51 10.6716 51 11.5C51 12.3284 51.6716 13 52.5 13Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1271 9.43432L83.3776 9.40318C84.038 9.40225 84.574 9.93681 84.575 10.5972C84.575 10.5972 84.575 10.5972 84.575 10.5972C84.5759 11.2575 84.0413 11.7936 83.381 11.7945L61.1304 11.8256C60.4701 11.8266 59.934 11.292 59.9331 10.6317C59.9331 10.6316 59.9331 10.6316 59.9331 10.6316C59.9321 9.97131 60.4667 9.43524 61.1271 9.43432Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 112C70.2091 112 72 110.209 72 108C72 105.791 70.2091 104 68 104C65.7909 104 64 105.791 64 108C64 110.209 65.7909 112 68 112Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 111C69.6569 111 71 109.657 71 108C71 106.343 69.6569 105 68 105C66.3431 105 65 106.343 65 108C65 109.657 66.3431 111 68 111Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 79H67V102H69V79Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 79H67V101H69V79Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 94,
    width: 61,
    height: 34,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 128H90L84 133V128Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -305,
    y: -82,
    width: 756,
    height: 620,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 68.2097,
    y1: 245.094,
    x2: 67.8693,
    y2: 1.3186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 68,
    y1: 112,
    x2: 68,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 68,
    y1: 102,
    x2: 68,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 244,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSms);
export default __webpack_public_path__ + "static/media/illustration_sms.bb88c0f7158ba5f865ac8e9fe4e83ef7.svg";
export { ForwardRef as ReactComponent };